<div
  class="tooltip-container"
  [class.position-top]="position === 'top'"
  [class.position-bottom]="position === 'bottom'"
>
  @if (isTemplate) {
    <ng-container *ngTemplateOutlet="templateContent"></ng-container>
  } @else {
    <span [innerHTML]="htmlString"></span>
  }
</div>
